import type { MouseEventHandler } from 'react';
import { usePopup } from '../../popup';
import { useSocialFeedSettings } from '../../utils';
import { usePost } from '../Post';

export function usePostAction(): MouseEventHandler<HTMLElement> | undefined {
  const {
    index,
    source: { url: sourceUrl }
  } = usePost();
  const { editMode, postAction, openLinksNewTab } = useSocialFeedSettings();
  const { open } = usePopup();

  if (postAction === 'popup') {
    return (e) => {
      let isLinkClick = false;

      if (e.target instanceof HTMLElement) {
        isLinkClick = !!e.target.closest('a');
      }

      if (isLinkClick) {
        return;
      }

      open(index);
    };
  }

  if (postAction === 'follow' && sourceUrl) {
    return () =>
      window.open(sourceUrl, openLinksNewTab || editMode ? '_blank' : '_top');
  }

  return;
}
